import { render, staticRenderFns } from "./record_book_add_student.vue?vue&type=template&id=b2b37812"
import script from "./record_book_add_student.vue?vue&type=script&lang=js"
export * from "./record_book_add_student.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports